import { gql, useQuery } from '@apollo/client'

import {
  CurrentUserFragmentDoc,
  GetUserFolloweesQuery,
  GetUserFolloweesQueryVariables,
} from '@/clients/utoniq-core/schema'
import { config } from '@/config'
import { useCurrentUser } from '@/core'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { user: currentUser, userClaims } = useCurrentUser()
  const { data, loading } = useQuery<
    GetUserFolloweesQuery,
    GetUserFolloweesQueryVariables
  >(GET_USER_FOLLOWEES, {
    skip: !currentUser?.isSigned,
  })

  return {
    state: {
      loading,
      artists: [],
      followees: data?.user?.organizationFollowees ?? null,
      user: data?.user ?? null,
      isArtist: !!userClaims?.orgs?.[config.organizationId]?.artist,
      followArtists: data?.user?.organizationFollowees ?? null,
      memberArtists: data?.user?.organizationPatrons ?? null,
    },
    actions: {},
  }
})

export const GET_USER_FOLLOWEES = gql`
  query GetUserFollowees {
    user {
      ...CurrentUser
    }
  }
  ${CurrentUserFragmentDoc}
`
